import ClassicEditorBase from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

const plugins = [];
const config = {};

class HtmlEditorSimple extends ClassicEditorBase {}
HtmlEditorSimple.builtinPlugins = plugins;
HtmlEditorSimple.defaultConfig = config;

class HtmlEditorClassic extends ClassicEditorBase {}
HtmlEditorClassic.builtinPlugins = plugins;
HtmlEditorClassic.defaultConfig = config;

class HtmlEditorPro extends ClassicEditorBase {}
HtmlEditorPro.builtinPlugins = plugins;
HtmlEditorPro.defaultConfig = config;

export {
    HtmlEditorSimple,
    HtmlEditorClassic,
    HtmlEditorPro,
};
